import { render, staticRenderFns } from "./sklTagManage.vue?vue&type=template&id=37f721cf&"
import script from "./sklTagManage.vue?vue&type=script&lang=js&"
export * from "./sklTagManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports